
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: 'PelvisAndUretertumors_TNM',
components: {
XTable
}
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Onco/PelvisAndUretertumors_TNM.vue